import { Button, Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material'
import React from 'react'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'

interface TableButtonDeleteProps {
    onClick: () => void
    nameOfEntityInDialogMessage: string
    /**
     * Default dialog message: Opravdu chcete {nameOfEntityInDialogMessage} smazat?
     */
    customDialogMessage?: string
}
const TableButtonDelete: React.FC<TableButtonDeleteProps> = ({
    onClick,
    nameOfEntityInDialogMessage: name,
    customDialogMessage: customMessage,
}: TableButtonDeleteProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    const confirmDeleteClient = () => {
        onClick()
        setIsDialogOpen(false)
    }

    return (
        <>
            <IconButton
                style={{
                    border: '1px solid',
                    borderRadius: '10%',
                    maxWidth: '28px',
                    maxHeight: '28px',
                    minWidth: '28px',
                    minHeight: '28px',
                    width: '28px',
                    height: '28px',
                }}
                color='error'
                onClick={handleOpenDialog}
            >
                <DeleteOutlineRoundedIcon style={{ width: '16px', height: '16px' }} />
            </IconButton>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>{customMessage ?? `Opravdu chcete ${name} smazat?`}</DialogTitle>

                <DialogActions>
                    <Button onClick={handleCloseDialog} variant='outlined'>
                        Ne
                    </Button>
                    <Button onClick={confirmDeleteClient} autoFocus color='error' variant='contained'>
                        Ano
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TableButtonDelete
